// import RegisterFormController from "../components/register/RegisterFormController";
import RequestFormController from "../components/register/RequestFormController";
import SignInFormController from "../components/signIn/signInFormController";

// const registerFormContainer = document.querySelector('.js-element--registerFormContainer');
const requestFormContainer = document.querySelector('.js-element--requestFormContainer');
const signInFormContainer = document.querySelector('.js-element--signInContainer');

// new RegisterFormController(registerFormContainer);
new RequestFormController(requestFormContainer);
new SignInFormController(signInFormContainer, onSucessCallBack);

function onSucessCallBack () {
    const urlParams = new URLSearchParams(window.location.search);
    const redirectUrl = urlParams.get('redirect');
    
    redirectUrl ? window.location.assign(decodeURIComponent(redirectUrl)) : window.location.assign('/');
}